import { useQuery } from '@tanstack/react-query'
import { orpc } from './contract'

export function useModelStyleKeys(modelVersionId?: string, enabled = false) {
  return useQuery({
    ...orpc.generationModel.getStyleKeys.queryOptions({
      // Fallback to '' (instead of non-null-assertion) so `queryOptions` always
      // receives a defined value. The query is gated by `enabled` below so the
      // empty-string key never actually fires.
      input: { modelVersionId: modelVersionId ?? '' },
    }),
    enabled: enabled && !!modelVersionId,
  })
}
